// import React, { useState } from 'react';
import React, { useState, useEffect } from 'react';
import axios from 'axios';


const HomeIngredient = ({uId}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [totalRows, setTotalRose] = useState(0);
    const totalPages = Math.ceil(totalRows / itemsPerPage);

    const handleClick = (type) => {
        if (type === 'prev') {
            setCurrentPage(currentPage === 1 ? 1 : currentPage - 1);
        } else if (type === 'next') {
            setCurrentPage(currentPage === totalPages ? totalPages : currentPage + 1);
        } else {
            setCurrentPage(type);
        }
    };
    const [ingredients, setIngredients] = useState([]);

    useEffect(() => {
        fetchIngredients();
    }, [uId]);
    const [smallMedia, setSmallMedia] = useState(window.innerWidth <= 768); // Adjust breakpoint as needed
    useEffect(() => {
        const handleResize = () => {
            setSmallMedia(window.innerWidth <= 768);
        };
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);

    const fetchIngredients = async () => { 
        try {
          const response = await axios.get(`http://localhost:5000/ingredients?userId=${uId}`);
          setIngredients(response.data);
          setTotalRose(response.data.length);
        } catch (error) {
          console.error('Error fetching ingredients:', error);
        }
      };
    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = Math.min(startIndex + itemsPerPage, ingredients.length);
        const rows = [];
    
        for (let i = startIndex; i < endIndex; i++) {
            rows.push(
                <tr key={i} className={`cl-ingre ${smallMedia ? "cl-ingre2" : ""}`}>
                    <td><div className="cell-content">{ingredients[i].name}</div></td>
                    <td><div className="cell-content">{ingredients[i].stock_level_ml}</div></td>
                </tr>
            );
        }
    
        return rows;
    };
    
    const small = {
        height: "30px",
        width: "25px",
        fontSize: "12px"
    }

    return (
        <div className="homeIngre homeIngre2">
            <div className= "stock-hh" >
                <div className="custom-h-s">Ingredient Stock</div>
            </div>
            <div className='tb2'>
                <table className="customTable" style={{width: '100%', borderCollapse: 'separate', borderSpacing: '1%', fontSize: '20px'}}>
                    <thead className="tb-head borderRow">
                        <tr style={{fontSize:"20px"}}>
                            <th>Name</th>
                            <th>Stock Level (ml)</th>
                        </tr>
                    </thead>
                    <tbody>{renderTableRows()}</tbody>
                </table>
            </div>
            <div className='bottomIngre'>

            <div className={`st-show ${smallMedia ? "st-show2" : ""}`} style={{fontSize:"10px", float:"left", width: "150px", marginLeft: 0 }}>
                <div className="onscreen">Showing {Math.min(((currentPage - 1) * itemsPerPage) + 1, totalRows)} to {Math.min(currentPage * itemsPerPage, totalRows)}</div>
                <div className="total">(Total {totalRows} entries)</div>
            </div>
              <div className={`h-pagenation ${smallMedia ? "h-pagenation2" : ""}`} style={{fontSize: "10px", textAlign:"right", padding: "0 10px 0 0"}}>
              <button onClick={() => handleClick('prev')} disabled={currentPage === 1} className='constbtn' style={{fontSize: "12px"}}>Previous</button>
                {[...Array(totalPages)].map((_, index) => (
                    <button key={index} onClick={() => handleClick(index + 1)}
                    className={`pbtn ${currentPage === index + 1  ? "active12a2a" : "" }`}
                    style={small}>{index + 1}</button>
                ))}
                <button onClick={() => handleClick('next')} disabled={currentPage === totalPages} className='constbtn' style={{fontSize: "12px"}}>Next</button>
              </div>

                
            </div>
        </div>
    );
};

export default HomeIngredient;
